import { Align } from "../utils/align";

// * HOME PAGE
// LANDING SECTION
if (window.innerWidth > 860) {
  window.addEventListener("load", () => {
    new Align(
      ".v_landing_home__button",
      ".v_landing_home__button .v_button_primary",
      Align.alignRight,
      { delta: -70 }
    );
  });
} else {
  window.addEventListener("load", () => {
    new Align(
      ".v_landing_home__button",
      ".v_landing_home__button .v_button_primary",
      Align.alignRight,
      { delta: -35 }
    );
  });
}

// MISSION SECTION
new Align(
  ".v_mission__button",
  ".v_mission__button .v_button_primary",
  Align.center
);

// SINGULARITY SECTION
new Align(
  ".v_singularity__button_container",
  ".v_singularity__button_container .v_button_primary",
  Align.center
);

// TEAM SECTION
new Align(".v_team__button", ".v_team__button .v_button_primary", Align.center);

// PARTNERSHIP SECTION
new Align(
  ".v_partnership__button",
  ".v_partnership__button .v_button_primary",
  Align.center
);

// PROPOSAL SECTION
new Align(
  ".v_proposal__button",
  ".v_proposal__button .v_button_primary",
  Align.center
);

// cta SECTION
new Align(".v_cta__button", ".v_cta__button .v_button_primary", Align.center);

// * NEWSROOM PAGE
// INDEX SECTION

if (window.innerWidth < 740) {
} else {
  new Align(
    ".v_newsroom_index__button",
    ".v_newsroom_index__button .v_button_primary",
    Align.alignRight,
    { multiple: true }
  );
}

// * IDENTITY PAGE
// LANDING SECTION
if (window.innerWidth > 860) {
  window.addEventListener("load", () => {
    new Align(
      ".v_landing_identity__button",
      ".v_landing_identity__button .v_button_primary",
      Align.alignRight,
      { delta: -70 }
    );
  });
} else {
  window.addEventListener("load", () => {
    new Align(
      ".v_landing_identity__button",
      ".v_landing_identity__button .v_button_primary",
      Align.alignRight,
      { delta: -35 }
    );
  });
}

// INVESTOR SECTION
new Align(
  ".v_investor__button",
  ".v_investor__button .v_button_primary",
  Align.center,
  { multiple: true }
);

// EXPERTS SECTION
if (window.innerWidth < 520) {
  new Align(
    ".v_experts__button",
    ".v_experts__button .v_button_primary",
    Align.center
  );
}

// RELAY SECTION
new Align(
  ".v_relay__button",
  ".v_relay__button .v_button_primary",
  Align.center
);

// ARMEN SECTION
new Align(
  ".v_armen__button",
  ".v_armen__button .v_button_primary",
  Align.center
);

// WE ARE SECTION
new Align(
  ".v_weare__button",
  ".v_weare__button .v_button_primary",
  Align.center
);

// PROFESSIONAL SECTION
new Align(
  ".v_professional__button",
  ".v_professional__button .v_button_primary",
  Align.center
);

// ESG SECTION
if (window.innerWidth < 520) {
  new Align(
    ".v_esg__button",
    ".v_esg__button .v_button_primary",
    Align.center,
    { multiple: true }
  );
}

// new Align(
//   ".v_esg__button",
//   ".v_esg__button .v_button_primary",
//   Align.alignLeft
// );

// * CONTACT PAGE
// LANDING SECTION
if (window.innerWidth > 860) {
  window.addEventListener("load", () => {
    new Align(
      ".v_landing_contact__button",
      ".v_landing_contact__button .v_button_primary",
      Align.alignRight,
      { delta: -70 }
    );
  });
} else {
  window.addEventListener("load", () => {
    new Align(
      ".v_landing_contact__button",
      ".v_landing_contact__button .v_button_primary",
      Align.alignRight,
      { delta: -35 }
    );
  });
}

// * OFFER PAGE
// LANDING SECTION
if (window.innerWidth > 860) {
  window.addEventListener("load", () => {
    new Align(
      ".v_landing_offer__button",
      ".v_landing_offer__button .v_button_primary",
      Align.alignRight,
      { delta: -70 }
    );
  });
} else {
  window.addEventListener("load", () => {
    new Align(
      ".v_landing_offer__button",
      ".v_landing_offer__button .v_button_primary",
      Align.alignRight,
      { delta: -35 }
    );
  });
}
